<template>
  <div>
    <ProgressBar :max="totalSteps" :value="currentStep" :content="progressContent" class="sticky top-0" />
    <RouteStepper class="w-full mt-32 md:mt-60 md:max-w-[568px] px-16 mx-auto" @progress="onProgress" :hideBreadcrumb="true" />
  </div>
</template>

<script lang="ts">
import RouteStepper from '@/components/route_stepper/RouteStepper.vue';
import ProgressBar from '@/components/progress_bar/ProgressBar.vue';

interface OnboardingSeekerData {
  currentStep: number;
  totalSteps: number;
}

export default {
  name: 'OnboardingSeeker',
  components: { RouteStepper, ProgressBar },
  data(): OnboardingSeekerData {
    return {
      currentStep: 1,
      totalSteps: 1,
    };
  },
  computed: {
    progressContent(): string {
      return `Step ${this.currentStep} of ${this.totalSteps}`;
    },
  },
  methods: {
    onProgress({ currentStep, totalSteps }: { currentStep: number; totalSteps: number }): void {
      this.currentStep = currentStep;
      this.totalSteps = totalSteps;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .card:not(.card-preserve) {
  padding: 24px;

  @media (max-width: 640px) {
    background-color: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
  }
}
</style>
